import { isAnyArray } from 'is-any-array';
/**
 * Checks if the input is a non-empty array of numbers.
 * Only checks the first element.
 * @param input - array to check.
 * @param options - additional checks.
 * @returns Whether the value is a valid array of numbers.
 */
export function xIsArray(input, options = {}) {
    const { minLength = 1 } = options;
    return (isAnyArray(input) &&
        input.length > 0 &&
        typeof input[0] === 'number' &&
        input.length >= minLength);
}
//# sourceMappingURL=xIsArray.js.map